import { createApp } from 'vue'
import App from './app'

import '@/plugins/flexible.js'
import '__assets/common.less'
import './style'

const app = createApp(App)
app.mount('#app')
